import orderBy from 'lodash.orderby';
import { Winning } from '../types/prize.types';
import { SORT_TYPE, PRIZE_TYPE } from '../constants/sort';
import { PAYMENT_STATUS } from '../types/payout.types';

const getDate = (item: Winning): number => Date.parse(item.dateOfEvent);

const getPaidStatus = (item: Winning): number => {
    if (item.prizeType === PRIZE_TYPE.PHYSICAL_GOODS) {
        return item.markedOfflinePay ? 1 : 0;
    }
    return item.paymentStatus === PAYMENT_STATUS.COMPLETED || item.markedOfflinePay ? 1 : 0;
};

const byRecent = (items: Winning[]) => orderBy(items, [getDate], ['desc']);
const byGameTitle = (items: Winning[]) => orderBy(items, ['gameId', getDate], ['asc', 'desc']);
const byUnpaid = (items: Winning[]) => orderBy(items, [getPaidStatus, getDate], ['asc', 'desc']);
const byPaid = (items: Winning[]) => orderBy(items, [getPaidStatus, getDate], ['desc', 'desc']);

export const sortPrizes = (prizes: Winning[], sortType: SORT_TYPE): Winning[] => {
    if (sortType === SORT_TYPE.MOST_RECENT) {
        return byRecent(prizes);
    } else if (sortType === SORT_TYPE.GAME_TITLE) {
        return byGameTitle(prizes);
    } else if (sortType === SORT_TYPE.UNPAID_TO_PAID) {
        return byUnpaid(prizes);
    } else if (sortType === SORT_TYPE.PAID_TO_UNPAID) {
        return byPaid(prizes);
    }
    return prizes;
};

export const isValidSortType = (sortType: string): sortType is SORT_TYPE => {
    return Object.values(SORT_TYPE).includes(sortType as SORT_TYPE);
};

export const getDefaultSortType = (): SORT_TYPE => SORT_TYPE.MOST_RECENT;

export const getSortOptions = () => Object.values(SORT_TYPE);
